<script>
import Checkbox from '@/components/Common/Checkbox';
import MinProbeg from '../Svg/Filter/MinProbeg.vue';
import OneOwner from '../Svg/Filter/OneOwner.vue';
import CoolCars from '../Svg/Filter/CoolCars.vue';
import Family from '../Svg/Filter/Family.vue';
import Garanty from '../Svg/Filter/Garanty.vue';
import Nalog from '../Svg/Filter/Nalog.vue';
import Novinki from '../Svg/Filter/Novinki.vue';
export default {
  name: 'MainFilterItem',
  components: {
    Checkbox,
    MinProbeg,
    OneOwner,
    CoolCars,
    Family,
    Garanty,
    Nalog,
    Novinki
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isItemSelected: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['on-item-click'],
  data() {
    return {
      checked: this.isItemSelected,
      checkbox: false,
    };
  },
  watch: {
    isItemSelected() {
      this.checked = this.isItemSelected;
    },
  },
  methods: {
    onItemClick() {
      this.$emit('on-item-click', this.item, this.checked, this.name);
    },
  },
};
</script>

<template>
  <div class="flex items-center" :class="{ fill: hidden && !checked, active: checked && hidden, 'pointer-events-none': disabled }">
    <min-probeg :item="item" v-if="hidden && name === 'min_probeg'" />
    <one-owner v-if="hidden && name === 'one_owner'" />
    <cool-cars v-if="hidden && name === 'cool_cars'" />
    <family v-if="hidden && name === 'for_family'" />
    <garanty v-if="hidden && name === 'has_warranty'" />
    <nalog v-if="hidden && name === 'nizkiy_nalog'" />
    <novinki v-if="hidden && name === 'novinki_nedeli'" />

    <checkbox
      :hidden="hidden"
      v-model="checkbox"
      :checked="checked"
      @on-click="onItemClick"
      :darker="['credit','nds'].includes(this.name)"
    >
      <slot></slot>
      <span
        class=" ml-1 "
        :class="{ 'color-green-500': hidden, 'font-fira': hidden, 'color-red-200': name === 'novinki_nedeli', 'line-through': disabled }"
        >{{ item.name }}</span
      >
    </checkbox>
  </div>
  <div
    v-if="item.count"
    class="px-2 text-xs leading-5 text-white rounded-brand ml-2 bg-green"
  >
    {{ item.count }}
  </div>
</template>
<style scoped>
.active span {
  color: white !important;
}

.color-green-500 {
  color: #557925;
}

.color-red-200 {
  color: #EC601F !important;
}

.fill svg path {
  stroke: #557925 !important;
  fill: white !important;
  stroke-width: 1px !important;
}

.min_probeg {
  stroke: white !important;
  fill: red !important;
}


</style>
